export function logoSwap(selector) {
    const el = document.querySelector(selector)
    const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1),
        { threshold: [1] }
    );

    observer.observe(el);
}